var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.485 20.485"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#f05a5c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-name": "Icon feather-search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.032 8.016A7.016 7.016 0 1 1 8.016 1a7.016 7.016 0 0 1 7.016 7.016",
    "data-name": "Path 36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.071 19.071-6.095-6.095",
    "data-name": "Path 37"
  }))));
};
export default SvgSearchIcon;